// @type
import ReactHtml from 'react-html-parser';
import { XmlEntities } from 'html-entities';

type Props = {
  text: string
};

const SafeHTML = ({ text }: Props) => {
  const entities = new XmlEntities();
  const decodedText = entities.decode(text);
  return ReactHtml(decodedText);
};

export default SafeHTML;


// WEBPACK FOOTER //
// ./src/components/shared/SafeHTML.js